<template>
    <ButtonLogin 
        mode="callback" 
        size="large"
        :bot-username="bot_name" 
        @callback="loginWithTelegram" 
    />
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import Event from '@/assets/js/Event'
import { ButtonLogin } from 'televue'
import { mapActions } from "vuex"
import { useCookies } from "vue3-cookies"

export default {
    props: ['redirect', 'reload'],
	data(){
		return{
			cookies: useCookies(),
            isLoading: false,
            bot_name: 'paywave_auth_bot',
            messages: {
                en:{
                    title: 'Success',
                    subtitle: 'Successful authorization',
                },
                ru:{
                    title: 'Успех',
                    subtitle: 'Успешная авторизация',
                }
            },
		}
	},
    components: {
        ButtonLogin
    },
	methods: {
        get_utm_from_meta(store, coockie, localstorage){
            return this.helper.get_utm_from_meta(store, coockie, localstorage)
        },
		...mapActions(['ActionTgLogin', 'ActionGetAllWallets']),
        async loginWithTelegram(user){
            this.isLoading = true
            this.event.send('authDo')

            // читаем store, cookie, localstorage на наличие UTM меток
            const utm_store = this.$store.getters.StateUtm
            const utm_cookie = this.cookies.cookies.get("utm")
            const utm_localstorage = JSON.parse(localStorage.getItem('utm'))
            const utm = this.helper.get_utm_from_meta(utm_store, utm_cookie, utm_localstorage)

            // читаем store, cookie, localstorage на наличие REF меток
            const ref_store = this.$store.getters.StateRef
            const ref_cookie = this.cookies.cookies.get("ref")
            const ref_localstorage = localStorage.getItem('ref')
            const ref = this.helper.get_ref_from_meta(ref_store, ref_cookie, ref_localstorage)

            const ref_utm_data = {
                ref: ref,
                utm: utm,
                reload: true
            }
            
            const result_data = {...user, ...ref_utm_data} 

            try {
                const login = await this.ActionTgLogin(result_data).then(res=>res)
                if(login.result && login.data){

                    this.showMess('success', this.messages[this.lang].title, this.messages[this.lang].subtitle) 
                    this.event.send('authSuccess')
                    this.isLoading = false

                    try { await this.ActionGetAllWallets().then(() => {})
                    } catch { console.log('error ActionGetAllWallets')}

                    // если во входящих props есть ссылка для редиректа, то переходим по ней
                    if(this.redirect) this.$router.push({ path: this.redirect })
                    else this.$router.push({ path: '/' })

                    // если во входящих props есть флаг reload, то перезагружаем страницу
                    if(this.reload==true) location.reload()

                } else {
                    this.isLoading = false
                    if(login.errors) {
                        for (let i = 0; i < login.errors.length; i++) {
                            this.showMess('error', 'Error', login.errors[i])
                        }
                    } else {
                        this.showMess('error', 'Error', 'Authorisation Error')
                    }
                }
            } catch (error) {
                console.log('error', error)
                this.showMess('error', 'Error', 'Authorisation Error')
                this.isLoading = false
            }
        },
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
	},
    computed: {
        lang() { 
            if(this.$i18n && this.$i18n.locale) return this.$i18n.locale
            if(this.$store.getters.StateLang) return this.$store.getters.StateLang
            return 'ru' 
        },
        bot_name() {
            return (process.env.VUE_APP_AUTH_BOT) ? this.bot_name = process.env.VUE_APP_AUTH_BOT : this.bot_name
        }
    },
	async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
        this.event = new Event(this)
	},
    mounted() {

    }
}
</script>